/**
 * Task SG: Owner Settings grouped navigation (left menu on desktop / tablet, list → sub-page on phones) + search.
 * One row per key: [key, English, 中文] — English + 中文 only (ms falls back to English). Registered in ../modules.ts.
 */
const ROWS = [
  ["sg.search", "Search settings", "搜索设置"],
  ["sg.noResults", "No setting matches.", "没有匹配的设置。"],
  ["sg.back", "All settings", "全部设置"],
  ["sg.g.shop", "Shop profile", "店铺资料"],
  ["sg.g.pay", "Payments & checkout", "收款与收银"],
  ["sg.g.customers", "Customers & marketing", "顾客与营销"],
  ["sg.g.team", "Team & permissions", "团队与权限"],
  ["sg.g.notify", "Notifications", "通知"],
  ["sg.g.account", "Account & plan", "账户与订阅"],
  ["sg.g.tools", "Tools & data", "工具与数据"],
  ["sg.g.device", "Device", "设备"],
  ["sg.item.team", "Staff", "员工"],
  ["sg.item.domain", "Website domain", "网站域名"],
  ["sg.item.device", "This device", "这台设备"],
] as const;

export type SgKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<SgKey, string>;

export const taskSG = { en: col(1), zh: col(2), ms: col(1) };
